import '../styles/LandingPage/Hero.css';
import Advert from '../LandingpageHooks/Advert/Advert.js';

/* ── Molecule network node positions (fixed seed for determinism) ── */
const MOLECULE_NODES = [
  { x: 62,  y: 9   }, { x: 18,  y: 22  }, { x: 78,  y: 31  },
  { x: 45,  y: 18  }, { x: 88,  y: 55  }, { x: 30,  y: 48  },
  { x: 55,  y: 62  }, { x: 72,  y: 74  }, { x: 15,  y: 70  },
  { x: 40,  y: 82  }, { x: 85,  y: 85  }, { x: 22,  y: 38  },
  { x: 65,  y: 45  }, { x: 50,  y: 35  }, { x: 92,  y: 22  },
  { x: 8,   y: 55  }, { x: 35,  y: 65  }, { x: 70,  y: 18  },
  { x: 48,  y: 92  }, { x: 80,  y: 68  }, { x: 25,  y: 12  },
  { x: 58,  y: 88  }, { x: 12,  y: 85  }, { x: 95,  y: 42  },
  { x: 42,  y: 52  }, { x: 68,  y: 58  }, { x: 20,  y: 95  },
  { x: 90,  y: 10  }, { x: 36,  y: 28  }, { x: 75,  y: 90  },
];

const MOLECULE_EDGES = [
  [0,4],[0,2],[1,5],[1,3],[2,4],[2,12],[3,11],[3,13],
  [4,7],[5,8],[5,16],[6,9],[6,13],[7,10],[7,19],[8,15],
  [9,16],[10,21],[11,13],[12,13],[12,24],[13,25],[14,23],
  [15,22],[16,17],[17,0],[18,21],[19,25],[20,3],[24,25],
  [26,22],[27,14],[28,11],[29,10],[1,20],[6,24],[18,9],
];

function MoleculeNetwork() {
  return (
    <svg
      className="hero-molecule-svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <defs>
        <filter id="nodeGlow" x="-80%" y="-80%" width="260%" height="260%">
          <feGaussianBlur stdDeviation="0.6" result="blur"/>
          <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <filter id="edgeGlow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="0.25" result="blur"/>
          <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
      </defs>

      <g filter="url(#edgeGlow)">
        {MOLECULE_EDGES.map(([a, b], i) => {
          const na = MOLECULE_NODES[a];
          const nb = MOLECULE_NODES[b];
          const delay = (i * 0.18) % 4;
          return (
            <line
              key={i}
              x1={na.x} y1={na.y}
              x2={nb.x} y2={nb.y}
              className="mol-edge"
              style={{ animationDelay: `${delay}s` }}
            />
          );
        })}
      </g>

      <g filter="url(#nodeGlow)">
        {MOLECULE_NODES.map((n, i) => {
          const delay = (i * 0.22) % 5;
          const isHub = i % 5 === 0;
          return (
            <circle
              key={i}
              cx={n.x} cy={n.y}
              r={isHub ? 1.05 : 0.55}
              className={isHub ? 'mol-node mol-hub' : 'mol-node'}
              style={{ animationDelay: `${delay}s` }}
            />
          );
        })}
      </g>
    </svg>
  );
}

function AfricaMapSVG() {
  return (
    <svg
      className="hero-africa-svg"
      viewBox="0 0 1000 560"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="afGlow" cx="50%" cy="55%" r="45%">
          <stop offset="0%"   stopColor="rgba(15,158,138,0.22)"/>
          <stop offset="100%" stopColor="rgba(15,158,138,0)"/>
        </radialGradient>
        <pattern id="mapdots" x="0" y="0" width="14" height="14" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1" fill="rgba(15,158,138,0.1)"/>
        </pattern>
      </defs>

      <rect width="1000" height="560" fill="url(#mapdots)" opacity="0.7"/>

      <g stroke="rgba(15,158,138,0.07)" strokeWidth="0.5" fill="none">
        {[112,168,224,336,392,448].map((y, i) => (
          <line key={`h${i}`} x1="0" y1={y} x2="1000" y2={y} strokeDasharray="6 10"/>
        ))}
        <line x1="0" y1="280" x2="1000" y2="280"
              strokeWidth="0.8" stroke="rgba(15,158,138,0.18)"/>
        {[125,250,375,500,625,750,875].map((x, i) => (
          <line key={`v${i}`} x1={x} y1="0" x2={x} y2="560" strokeDasharray="6 10"/>
        ))}
      </g>

      <ellipse cx="490" cy="330" rx="230" ry="270" fill="url(#afGlow)"/>

      <g fill="rgba(15,158,138,0.12)" stroke="rgba(15,158,138,0.42)" strokeWidth="0.9">
        <path d="M400,120 L520,118 L545,130 L550,160 L540,185 L510,195 L490,210 L470,215 L445,205 L420,200 L395,185 L388,160 Z"/>
        <path d="M380,185 L395,185 L420,200 L445,205 L490,215 L540,220 L580,218 L610,225 L630,240 L625,270 L610,295 L590,310 L560,320 L530,315 L500,325 L470,320 L440,315 L410,305 L390,285 L375,260 L370,230 Z"/>
        <path d="M355,235 L380,228 L395,240 L405,260 L410,280 L405,300 L395,315 L375,320 L360,310 L345,295 L340,275 L342,255 Z"/>
        <path d="M410,305 L440,315 L470,320 L500,325 L530,320 L550,330 L560,355 L555,380 L535,400 L510,415 L485,420 L460,415 L435,405 L415,390 L400,365 L395,340 L400,315 Z"/>
        <path d="M590,270 L630,260 L665,270 L685,295 L675,325 L655,345 L630,360 L605,365 L580,355 L560,340 L555,315 L565,290 Z"/>
        <path d="M460,415 L510,415 L540,425 L560,445 L560,475 L545,495 L520,505 L495,500 L470,490 L450,470 L440,445 Z"/>
        <path d="M440,460 L480,455 L510,455 L535,465 L550,485 L545,510 L525,530 L495,540 L465,535 L440,520 L425,500 L425,475 Z"/>
        <path d="M605,390 L625,385 L640,400 L640,430 L625,450 L608,445 L598,425 L600,405 Z"/>
      </g>

      <g fill="rgba(15,158,138,0.04)" stroke="rgba(15,158,138,0.13)" strokeWidth="0.6">
        <path d="M380,20 L500,18 L555,25 L580,45 L570,70 L545,85 L515,90 L480,88 L450,80 L420,68 L395,55 L378,40 Z"/>
        <path d="M330,30 L380,25 L390,50 L380,70 L355,78 L332,68 L320,50 Z"/>
        <path d="M500,20 L600,18 L650,30 L655,55 L635,72 L600,80 L565,78 L535,68 L510,55 L498,38 Z"/>
        <path d="M600,25 L700,22 L740,38 L738,62 L710,78 L675,82 L645,72 L628,55 L630,35 Z"/>
      </g>

      <g fill="rgba(15,158,138,0.03)" stroke="rgba(15,158,138,0.09)" strokeWidth="0.6">
        <path d="M550,130 L640,125 L690,140 L700,165 L685,190 L655,200 L625,198 L595,185 L568,170 L548,155 Z"/>
        <path d="M640,170 L700,165 L735,175 L740,200 L720,220 L695,228 L665,222 L645,205 Z"/>
      </g>

      <g fill="rgba(15,158,138,0.02)" stroke="rgba(15,158,138,0.06)" strokeWidth="0.5">
        <path d="M720,150 L820,145 L870,160 L875,195 L850,220 L815,235 L778,230 L745,210 L725,185 Z"/>
        <path d="M820,200 L875,195 L910,210 L915,240 L895,260 L860,265 L830,250 L815,230 Z"/>
      </g>

      <g fill="rgba(15,158,138,0.02)" stroke="rgba(15,158,138,0.05)" strokeWidth="0.4">
        <path d="M0,80 L60,75 L100,90 L105,130 L80,160 L45,165 L10,145 L0,120 Z"/>
        <path d="M0,160 L55,155 L85,175 L90,220 L65,250 L30,255 L0,235 Z"/>
        <path d="M0,260 L50,255 L80,275 L82,320 L55,345 L18,342 L0,318 Z"/>
        <path d="M20,360 L70,352 L98,375 L95,420 L70,440 L35,435 L8,415 L5,385 Z"/>
      </g>
    </svg>
  );
}

function VideoBackground() {
  return (
    <video
      className="hero-video-bg"
      src="/Herro Clip.mp4"
      autoPlay
      loop
      muted
      playsInline
      aria-hidden="true"
    />
  );
}

function PulsePin({ style }) {
  return (
    <div className="map-pulse" style={style}>
      <div className="pulse-ring" />
      <div className="pulse-ring" />
      <div className="pulse-ring" />
      <div className="pulse-core" />
    </div>
  );
}

function CompareQuotesButton() {
  return (
    <a
      href="https://actyra.vercel.app/"
      target="_blank"
      rel="noopener noreferrer"
      className="compare-quotes-btn"
      aria-label="Compare insurance quotes on Actyra"
    >
      <div className="compare-btn-shimmer" />
      <div className="compare-btn-content">
        <div className="compare-btn-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
            <path d="M3 3v18h18V3H3zm16 16H5V5h14v14z" opacity="0.3" />
          </svg>
        </div>
        <div className="compare-btn-text">
          <span className="compare-btn-headline">Compare Insurance</span>
          <span className="compare-btn-sub">with Clarity</span>
        </div>
        <div className="compare-btn-arrow">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7 17L17 7M17 7H7M17 7v10" />
          </svg>
        </div>
      </div>
      <div className="compare-btn-glow" />
    </a>
  );
}

/* ── MOBILE-ONLY: Floating stat ticker ── */
function MobileStatTicker() {
  const stats = [
    { num: '54', label: 'African Markets' },
    { num: '5',  label: 'Research Pillars' },
    { num: '01', label: 'Active Phase' },
  ];
  return (
    <div className="mobile-stat-ticker" aria-hidden="true">
      {stats.map((s, i) => (
        <div className="mst-item" key={i}>
          <span className="mst-num">{s.num}</span>
          <span className="mst-label">{s.label}</span>
          {i < stats.length - 1 && <span className="mst-sep" />}
        </div>
      ))}
    </div>
  );
}

/* ── MOBILE-ONLY: Horizontal research pill strip ── */
function MobileResearchStrip() {
  const items = [
    { color: 'teal',    label: 'IFRS 17',          sub: 'Financial Reporting' },
    { color: 'green',   label: 'Capital',           sub: 'Solvency & Stress' },
    { color: 'crimson', label: 'Climate Risk',      sub: 'Parametric Models' },
  ];
  return (
    <div className="mobile-research-strip">
      <div className="mrs-label">Current Research Focus</div>
      <div className="mrs-pills">
        {items.map((item, i) => (
          <div className={`mrs-pill mrs-pill--${item.color}`} key={i}>
            <div className={`mrs-dot mrs-dot--${item.color}`} />
            <div className="mrs-pill-text">
              <span className="mrs-pill-main">{item.label}</span>
              <span className="mrs-pill-sub">{item.sub}</span>
            </div>
            <div className={`mrs-badge`}>Active</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Hero() {
  return (
    <section className="hero" id="home">

      <Advert />

      {/* Layer 1 — video */}
      <div className="hero-map-bg">
        <VideoBackground />
      </div>

      {/* Layer 2 — Africa SVG map */}
      <div className="hero-africa-layer">
        <AfricaMapSVG />
      </div>

      {/* Layer 3 — molecule network */}
      <div className="hero-molecule-layer">
        <MoleculeNetwork />
      </div>

      {/* Gradient overlays */}
      <div className="hero-overlay-left" />
      <div className="hero-overlay-bottom" />
      <div className="hero-overlay-teal" />

      {/* Pulse pins */}
      <PulsePin style={{ top: '38%', left: '51%' }} />
      <PulsePin style={{ top: '28%', left: '49%' }} />
      <PulsePin style={{ top: '44%', left: '47%' }} />
      <PulsePin style={{ top: '25%', left: '44%' }} />
      <PulsePin style={{ top: '21%', left: '53%' }} />

      {/* ═══════════════════════════════════════════
          MOBILE LAYOUT  (hidden on desktop via CSS)
          ═══════════════════════════════════════════ */}
      <div className="hero-mobile-layout">

        {/* Top cinematic band — eyebrow + headline */}
        <div className="hm-top">
          <div className="hm-eyebrow">
            <span className="hm-eyebrow-pip" />
            Actuarial Research &amp; Thought Leadership
          </div>

          <h1 className="hm-headline">
            Clarity in<br />
            <span className="hm-headline-grad">Risk &amp; Capital.</span>
          </h1>

          <p className="hm-desc">
            Independent actuarial insight across insurance, pensions &amp; risk —
            built for emerging markets across Africa.
          </p>
        </div>

        {/* Stat ticker */}
        <MobileStatTicker />

        {/* CTA pair */}
        <div className="hm-cta-row">
          <a href="#research" className="hm-btn-primary">
            Explore Research
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
          <a href="#advisory" className="hm-btn-ghost">Advisory</a>
        </div>

        {/* Compare block — full-width card */}
        <div className="hm-compare-block">
          <div className="hm-compare-label">
            <span className="hm-compare-label-dash" />
            Featured Tool
          </div>
          <CompareQuotesButton />
          <div className="hm-compare-features">
            {['Transparent Pricing','Side-by-Side','Plain Language'].map((f,i) => (
              <span className="hm-feature-tag" key={i}>
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                {f}
              </span>
            ))}
          </div>
        </div>

        {/* Research focus strip */}
        <MobileResearchStrip />

        {/* Bottom identity pair */}
        <div className="hm-identity-row">
          <div className="hm-id-card hm-id-card--teal">
            <div className="hm-id-icon">
              <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" strokeWidth="1.5" stroke="currentColor"/><path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20" strokeWidth="1.5" stroke="currentColor"/></svg>
            </div>
            <div className="hm-id-label">Focus</div>
            <div className="hm-id-value">Emerging<br/>Markets</div>
          </div>
          <div className="hm-id-card hm-id-card--crimson">
            <div className="hm-id-icon">
              <svg viewBox="0 0 24 24" fill="none"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" strokeWidth="1.5" stroke="currentColor" strokeLinejoin="round"/></svg>
            </div>
            <div className="hm-id-label">Approach</div>
            <div className="hm-id-value">Research<br/>First</div>
          </div>
        </div>

      </div>

      {/* ═══════════════════════════════════════════
          DESKTOP LAYOUT (hidden on mobile via CSS)
          ═══════════════════════════════════════════ */}
      <div className="hero-content hero-desktop-only">

        <div className="hero-left">
          <div className="hero-eyebrow">
            <span className="eyebrow-dash" />
            Actuarial Research &amp; Thought Leadership
          </div>

          <h1>
            Clarity in<br />
            <span className="italic-grad">Risk &amp; Capital.</span>
          </h1>

          <p className="hero-desc">
            An independent actuarial research platform delivering rigorous,
            high-impact insight across insurance, pensions, and risk —
            built for emerging markets across Africa.
          </p>

          <div className="hero-actions">
            <a href="#research" className="btn-primary">
              Explore Research
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a href="#advisory" className="btn-outline">Advisory Services</a>
          </div>

          <div className="hero-compare-wrapper">
            <CompareQuotesButton />
            <p className="compare-quotes-caption">
              No more confusing policies or hidden costs. See quotes from 15+ insurers
              side-by-side, understand exactly what you're buying, and choose with confidence.
            </p>
            <div className="compare-quotes-features">
              <span className="compare-feature">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                Transparent Pricing
              </span>
              <span className="compare-feature">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                Side-by-Side Comparison
              </span>
              <span className="compare-feature">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5" /></svg>
                Plain Language Explanations
              </span>
            </div>
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-num"><span className="grad-num">54</span></div>
              <div className="stat-label">African Markets</div>
            </div>
            <div className="stat-item">
              <div className="stat-num"><span className="grad-num">5</span></div>
              <div className="stat-label">Research Pillars</div>
            </div>
            <div className="stat-item">
              <div className="stat-num"><span className="grad-num">01</span></div>
              <div className="stat-label">Active Phase</div>
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="focus-card">
            <div className="focus-card-title">Current Research Focus Areas</div>

            <div className="focus-row">
              <div className="focus-icon fi-teal">
                <svg viewBox="0 0 24 24">
                  <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <div className="focus-text-group">
                <div className="focus-label">Financial Reporting</div>
                <div className="focus-value">IFRS 17 &amp; Capital Frameworks</div>
              </div>
              <div className="focus-badge">Active</div>
            </div>

            <div className="focus-row">
              <div className="focus-icon fi-green">
                <svg viewBox="0 0 24 24">
                  <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <div className="focus-text-group">
                <div className="focus-label">Solvency</div>
                <div className="focus-value">Capital &amp; Stress Testing</div>
              </div>
              <div className="focus-badge">Active</div>
            </div>

            <div className="focus-row">
              <div className="focus-icon fi-crimson">
                <svg viewBox="0 0 24 24">
                  <path d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="focus-text-group">
                <div className="focus-label">Emerging Risk</div>
                <div className="focus-value">Climate &amp; Parametric Models</div>
              </div>
              <div className="focus-badge">Active</div>
            </div>
          </div>

          <div className="hero-mini-row">
            <div className="mini-card">
              <div className="mini-card-accent accent-teal" />
              <div className="mini-card-icon mci-teal">
                <svg viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
                    strokeWidth="0" fill="currentColor" style={{ fill: 'var(--teal)' }} />
                </svg>
              </div>
              <div className="mini-card-label">Focus</div>
              <div className="mini-card-value">Emerging Markets</div>
            </div>

            <div className="mini-card">
              <div className="mini-card-accent accent-crimson" />
              <div className="mini-card-icon mci-crimson">
                <svg viewBox="0 0 24 24">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                </svg>
              </div>
              <div className="mini-card-label">Approach</div>
              <div className="mini-card-value">Research First</div>
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-hint">
        <span>Scroll</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
}